import { Typography } from '@mui/material'
import { useFormatMessage } from 'localization'
import { AddonSelectorContext } from 'pages/addon-selector-page/contexts/addon-selector-context'
import React from 'react'
import { useFormatPrice } from 'utilities/use-format-price'

type Props = { summaryView?: boolean }
const PriceDisplayView = (props: React.PropsWithChildren<Props>) => {
  const { summaryView = false } = props
  const { productsSum, hasOfferedPrice } = AddonSelectorContext.useState()

  const formatPrice = useFormatPrice()
  const f = useFormatMessage()

  return (
    <div>
      <Typography variant="overline" className="whitespace-nowrap">
        {f('PRICE_DISPLAY_CAPTION_LABEL')}
        {summaryView && hasOfferedPrice && (
          <Typography color="error" variant="overline" className="font-bold whitespace-nowrap">
            {` (${f('USE_FORMAT_TOTAL_PRICE_LABEL')})`}
          </Typography>
        )}
      </Typography>
      <Typography variant="h5" className="bold">
        {formatPrice(productsSum ?? 0)}
      </Typography>
    </div>
  )
}

export default PriceDisplayView
